import { render, staticRenderFns } from "./detailBox.vue?vue&type=template&id=297ed5ed&scoped=true&"
import script from "./detailBox.vue?vue&type=script&lang=js&"
export * from "./detailBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297ed5ed",
  null
  
)

export default component.exports